import React, { FC } from "react"
import { graphql, useStaticQuery } from "gatsby"

import { HubspotFormFragmentFragment } from "@graphqlTypes"

import HubspotForm, { HubspotFormProps } from "../HubspotForm"

const NewsletterForm: FC<HubspotFormProps> = ({
  ...props
}) => {
  const { newsletterForm } = useStaticQuery<{ newsletterForm: HubspotFormFragmentFragment }>(graphql`
    query NewsletterFormQuery {
      newsletterForm: hubspotForm(alternative_id: {eq: "e9c727e3-322b-4443-b6bc-5ef8828b7078"}) {
        ...HubspotFormFragment
      }
    }
  `)

  if (!newsletterForm) return null

  return (
    <HubspotForm
      {...newsletterForm}
      {...props}
    />
  )
}

export default NewsletterForm
